import Events from './Events.js';

let instance = null;

export default class EventEmitter {
    constructor() {
        // Singleton
        // eslint-disable-next-line no-constructor-return
        if (instance) return instance;

        instance = this;
        this.callbacks = {};
    }

    on(events, subscriber, callback) {
        // Errors
        if (
            typeof events === 'undefined' ||
            events === '' ||
            !Object.values(Events).includes(events)
        ) {
            console.warn('invalid events');
            return false;
        }

        if (typeof subscriber === 'undefined' || subscriber === '') {
            console.warn('invalid subscriber');
            return false;
        }

        if (typeof callback === 'undefined') {
            console.warn('invalid callback');
            return false;
        }

        let inputEvents = [];
        if (events instanceof Array) {
            inputEvents = events;
        } else {
            inputEvents.push(events);
        }

        // Resolve events
        inputEvents.forEach((event) => {
            // Create event object if it does not exist
            if (!(this.callbacks[event] instanceof Object)) {
                this.callbacks[event] = {};
            }

            // Create subscriber array if it does not exist
            if (!(this.callbacks[event][subscriber] instanceof Array))
                this.callbacks[event][subscriber] = [];

            // Add callback
            this.callbacks[event][subscriber].push(callback);
        });

        return this;
    }

    off(events, subscriber) {
        // Errors
        if (
            typeof events === 'undefined' ||
            events === '' ||
            !Object.values(Events).includes(events)
        ) {
            console.warn('invalid events');
            return false;
        }

        if (typeof subscriber === 'undefined' || subscriber === '') {
            console.warn('invalid subscriber');
            return false;
        }

        let inputEvents = [];
        if (events instanceof Array) {
            inputEvents = events;
        } else {
            inputEvents.push(events);
        }

        // Resolve events
        inputEvents.forEach((event) => {
            // Remove callback array
            if (this.callbacks[event][subscriber] instanceof Array) {
                delete this.callbacks[event][subscriber];
            }

            if (Object.keys(this.callbacks[event]).length === 0) {
                delete this.callbacks[event];
            }
        });

        return this;
    }

    trigger(event, args) {
        // Errors
        if (
            typeof event === 'undefined' ||
            event === '' ||
            !Object.values(Events).includes(event)
        ) {
            console.warn('invalid event');
            return false;
        }

        let finalResult = null;
        let result = null;

        // Default args
        const params = !(args instanceof Array) ? [args] : args;

        // Cycle through the callbacks of the event
        if (this.callbacks[event] instanceof Object) {
            Object.keys(this.callbacks[event]).forEach((subscriber) => {
                if (this.callbacks[event][subscriber] instanceof Array) {
                    this.callbacks[event][subscriber].forEach((callback) => {
                        result = callback.apply(subscriber, params);

                        if (typeof finalResult === 'undefined') {
                            finalResult = result;
                        }
                    });
                }
            });
        }

        return finalResult;
    }
}
